"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbologyEncoder = void 0;
/**
 * Class helping to transform from SLD 1.0.0 to SLD 1.1.0 / Synbology Encoding
 *
 * @class SymbologyEncoder
 */
var SymbologyEncoder = /** @class */ (function () {
    function SymbologyEncoder() {
    }
    /**
     * Methods returns Symbology Encoding / SLD 1.1.0 from given GeoStyler
     * style Object
     * @param {Style} geoStylerStyle A GeoStyler-Style Style.
     * @param {Rule[]} rules The array of rules
     * @param {string} symbolizerUnits The units to use for symbolizers
     * @returns {object} The object representation of a SLD 1.1 Style
     * (readable with xml2js)
     */
    SymbologyEncoder.getSymbologyEncoding = function (geoStylerStyle, rules, symbolizerUnits) {
        var setTags = function (rulez, isFilterElement) {
            if (!(rulez instanceof Array)) {
                rulez = [rulez];
            }
            rulez.forEach(function (rule) {
                var _a, _b, _c;
                var keys = Object.keys(rule);
                for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    var key = keys_1[_i];
                    var val = rule[key][0];
                    // handle renaming of ogc filter attributes
                    if (key.toLowerCase() === 'filter') {
                        delete Object.assign(rule, (_a = {}, _a['ogc:' + key] = rule[key], _a))[key];
                        setTags(rule['ogc:' + key], true);
                        continue;
                    }
                    if (isFilterElement) {
                        if (key.toLowerCase().indexOf('property') > -1) {
                            rule[key].forEach(function (el) {
                                if (el.$ && el.$.escape) {
                                    // rename escape attribute
                                    el.$.escapeChar = el.$.escape;
                                    delete el.$.escape;
                                }
                            });
                        }
                    }
                    // do not change special attribute handlers or ogc namespaces
                    if (key === '$' || key === '_' ||
                        key.toLowerCase().indexOf('ogc:') > -1 ||
                        (rule[key].$ && rule[key].$.xmlns)) {
                        if (val instanceof Object) {
                            setTags([rule[key]], isFilterElement);
                        }
                        continue;
                    }
                    // add uom attribute to symbolizers
                    if (key.toLowerCase().indexOf('symbolizer') > -1) {
                        val.$ = {
                            uom: 'http://www.opengeospatial.org/se/units/' +
                                symbolizerUnits
                        };
                    }
                    if (key.toLowerCase() === 'cssparameter') {
                        // change naming of css and svg parameters
                        delete Object.assign(rule, (_b = {}, _b['se:SvgParameter'] = rule[key], _b))[key];
                        continue;
                    }
                    else if (!isFilterElement) {
                        // rename all other tags to include the "se" namespace
                        delete Object.assign(rule, (_c = {}, _c['se:' + key] = rule[key], _c))[key];
                    }
                    // recursive call ourselves
                    if (val instanceof Object) {
                        setTags([val], isFilterElement);
                    }
                }
            });
        };
        setTags(rules, false);
        return {
            StyledLayerDescriptor: {
                '$': {
                    'version': '1.1.0',
                    'xsi:schemaLocation': 'http://www.opengis.net/sld StyledLayerDescriptor.xsd',
                    'xmlns': 'http://www.opengis.net/sld',
                    'xmlns:ogc': 'http://www.opengis.net/ogc',
                    'xmlns:xlink': 'http://www.w3.org/1999/xlink',
                    'xmlns:xsi': 'http://www.w3.org/2001/XMLSchema-instance',
                    'xmlns:se': 'http://www.opengis.net/se'
                },
                'NamedLayer': [{
                        'se:Name': [geoStylerStyle.name || ''],
                        'UserStyle': [{
                                'se:Name': [geoStylerStyle.name || ''],
                                'se:FeatureTypeStyle': [{
                                        'se:Rule': rules
                                    }]
                            }]
                    }]
            }
        };
    };
    return SymbologyEncoder;
}());
exports.SymbologyEncoder = SymbologyEncoder;
exports.default = SymbologyEncoder;
